export default __webpack_public_path__ + "static/media/picture04.62e0cdfc.png";